//
//
//
//
//
//
//
//

export default {
  name: 'CollapsibleSectionHero',
  props: {
    square: {
      type: Boolean,
      default: false
    },
    ratio: {
      type: Number,
      default: undefined
    }
  },
  computed: {
    rootStyle() {
      if (this.ratio > 0) {
        return {
          paddingTop: `calc(min(${(1 / this.ratio) * 100}%, 100vh) + 30px)`
        };
      } else {
        return {};
      }
    }
  }
};
